import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { getUsuarioDetalle, postUpdateUsuario } from "../../../api/ApiService";
import PerfilEditarComponents from "./components/PerfilEditarComponents";


function EditarUsuarioPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);



    const [email, setEmail] = useState('');
    const [tester, setTester] = useState(false);
    const [sexoSearch, setSexoSearch] = useState('');
    const [sexoSelected, setSexoSelected] = useState({ label: 'Masculino', value: "masculino", id: 1 });
    const [dataUsuario, setDataUsuario] = useState(null);

    const stateToken = useSelector(state => state.reducerGlobal.token);


    const params = useParams();

    const { id } = params;
    // console.log("id", id);

    const navigate = useNavigate();


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleUsuarioDetalle();
            }
        }
    }, [id, stateToken]);


    //==========================================================funcion para enviar encuesta a la api
    const handleUsuarioDetalle = () => {
        getUsuarioDetalle(stateToken?.access_token, { id: id, canjes_per_page: 5, canjes_page: 1 })
            .then(response => {
                // console.log("getUsuarioDetalle", response);
                setCargando(true);
                setDataUsuario(response?.data?.usuario || null);
                setEmail(response?.data?.usuario?.user?.email);
                setTester(response?.data?.usuario?.tester === "1" ? true : false);

                //pasar a minuscula y comparar
                if (response?.data?.usuario?.sexo.toLowerCase() === "masculino") {
                    setSexoSelected({ label: 'Masculino', value: "masculino", id: 1 });
                } else if (response?.data?.usuario?.sexo.toLowerCase() === "femenino") {
                    setSexoSelected({ label: 'Femenino', value: "femenino", id: 2 });
                }

            })
            .catch(error => {
                console.log("error-getUsuarioDetalle", error);
                setLoadingGuardar(false);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };





    //=========================================================funcion para guardar
    const handleUpdate = () => {

        let body = {
            email: email,
            tester: tester ? 1 : 0,
            sexo: sexoSelected?.label,
        };

        //validar campos que no esten vacios
        if (email.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El email es obligatorio');

        } else if (sexoSelected === null) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El sexo es obligatorio');

        } else {

            setLoadingGuardar(true);


            handleUpdateEventoApi(body);
        }
    };


    //=============================================api de crear evento
    const handleUpdateEventoApi = (body) => {

        postUpdateUsuario(body, id, stateToken?.access_token)
            .then((response) => {
                console.log("response-postUpdateUsuario", response);
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Actualizado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/usuarios-app');
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdateUsuario", error);
                setLoadingGuardar(false);

                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };









    //=============================================funcion para buscar el sexo
    const handleSexoSearch = (event) => {
        console.log("event", event);
        setSexoSearch(event);
    };

    //=========================================================funcion para seleccionar el sexo
    const handleSexoSelected = (value) => {
        console.log("value-handleSexoSelected: ", value);
        setSexoSelected(value);


    };





    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">Perfil</h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden p-6">
                            <PerfilEditarComponents
                                email={email}
                                setEmail={setEmail}

                                tester={tester}
                                setTester={setTester}

                                sexoSelected={sexoSelected}
                                handleSexoSearch={handleSexoSearch}
                                handleSexoSelected={handleSexoSelected}

                                handleCancelar={handleCancelar}
                                handleUpdate={handleUpdate}

                                dataUsuario={dataUsuario}

                            />
                        </div>
                    ) :
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default EditarUsuarioPage;